/**
 * @module host
 */

import React from 'react';
import {appBridgeMiddlewareProptype, Middleware} from './';

export interface Context {
  appBridgeMiddleware: Middleware;
}

export interface Props {
  middleware: Middleware;
}

export class Provider extends React.Component<Props, never> {
  static childContextTypes = {
    appBridgeMiddleware: appBridgeMiddlewareProptype,
  };

  middleware: Middleware;

  constructor(props: Props) {
    super(props);
    this.middleware = props.middleware;
  }

  getChildContext(): Context {
    return {
      appBridgeMiddleware: this.middleware,
    };
  }

  render() {
    return React.Children.only(this.props.children);
  }
}



// WEBPACK FOOTER //
// ./src/host/Provider.tsx